/**
 * @generated SignedSource<<2dea50b62cab5240284fc582022b069e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProviderRegionStock = "AU" | "BR" | "CA" | "CN" | "EU" | "EU_ES" | "EU_LV" | "JP" | "MX" | "UK" | "US" | "_UNDEFINED";
import { FragmentRefs } from "relay-runtime";
export type productProvider_retailProduct$data = {
  readonly profitPercentage: number;
  readonly variants: ReadonlyArray<{
    readonly availabilityStatus: ReadonlyArray<{
      readonly region: ProviderRegionStock;
      readonly status: string;
    }>;
    readonly canRotate: boolean;
    readonly colorCode: string | null;
    readonly colorName: string | null;
    readonly imageUrl: string;
    readonly inStock: boolean;
    readonly isColored: boolean;
    readonly name: string;
    readonly price: string;
    readonly productId: number;
    readonly size: string;
    readonly variantID: number;
  }>;
  readonly " $fragmentType": "productProvider_retailProduct";
};
export type productProvider_retailProduct$key = {
  readonly " $data"?: productProvider_retailProduct$data;
  readonly " $fragmentSpreads": FragmentRefs<"productProvider_retailProduct">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "productProvider_retailProduct",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "profitPercentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductProviderProductVariant",
      "kind": "LinkedField",
      "name": "variants",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variantID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canRotate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "colorCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "colorName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isColored",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inStock",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "price",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AvailabilityStatus",
          "kind": "LinkedField",
          "name": "availabilityStatus",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "region",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductProviderRetailProduct",
  "abstractKey": null
};

(node as any).hash = "edc1f3729c341a8d9d31f885e292aa5b";

export default node;
